"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _clientAwsS = require("@devsta/client-aws-s3");

var _commonReact = require("@devsta/common-react");

var _BrandSummaryList = _interopRequireDefault(require("./BrandSummaryList"));

var _Subscription = _interopRequireDefault(require("./Subscription"));

var _ManageTeams = _interopRequireDefault(require("./ManageTeams"));

var _components = require("../../../common/components");

var _utils = require("../utils");

require("../styles/_organisation.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Organisation = /*#__PURE__*/function (_Component) {
  _inherits(Organisation, _Component);

  var _super = _createSuper(Organisation);

  function Organisation(props) {
    var _this;

    _classCallCheck(this, Organisation);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getOrganisationAndSubBrands, _yield$getOrganisatio, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getOrganisationAndSubBrands = _this.props.getOrganisationAndSubBrands;
              _context.prev = 1;
              _context.next = 4;
              return getOrganisationAndSubBrands();

            case 4:
              _yield$getOrganisatio = _context.sent;
              data = _yield$getOrganisatio.data;
              error = _yield$getOrganisatio.error;

              if (!(error || !data)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: true
              }));

            case 9:
              _this.retrieveBucketKeyUrls(data);

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);

              _this.setState({
                error: true
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "retrieveBucketKeyUrls", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        var _this$props, apolloClient, organisationId, _yield$Promise$all, _yield$Promise$all2, organisationWithImage, accountManagerWithImage, subBrandsWithImages;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, apolloClient = _this$props.apolloClient, organisationId = _this$props.organisationId;
                _context2.prev = 1;
                _context2.next = 4;
                return Promise.all([(0, _clientAwsS.replaceBucketKeysWithUrls)({
                  apiClient: apolloClient,
                  data: data.getOrganisation,
                  organisationId: organisationId,
                  substitutedKeys: ['imageUrl', 'brandingCoverImageKey']
                }), (0, _clientAwsS.replaceBucketKeysWithUrls)({
                  apiClient: apolloClient,
                  data: data.getOrganisation.accountManager,
                  organisationId: organisationId,
                  substitutedKeys: ['imageUrl']
                }), (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apolloClient,
                  dataArray: data.getOrganisationSubBrands,
                  substitutedKeys: ['coverImageKey']
                })]);

              case 4:
                _yield$Promise$all = _context2.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                organisationWithImage = _yield$Promise$all2[0];
                accountManagerWithImage = _yield$Promise$all2[1];
                subBrandsWithImages = _yield$Promise$all2[2];

                _this.setState({
                  organisationInfo: _objectSpread(_objectSpread({}, organisationWithImage), {}, {
                    accountManager: accountManagerWithImage
                  }),
                  subBrands: subBrandsWithImages
                });

                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);

                _this.setState({
                  organisationInfo: data.getOrganisation,
                  subBrands: data.getOrganisationSubBrands
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleDescriptionInputChange", function (result) {
      _this.setState(function (_ref3) {
        var organisationInfo = _ref3.organisationInfo;
        return {
          organisationInfo: _objectSpread(_objectSpread({}, organisationInfo), {}, {
            brandingDescription: (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEditDetailsBtnClick", function () {
      _this.setState({
        modal: 'edit-details'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseEditDetailsModal", function () {
      _this.setState({
        modal: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var updateOrganisation, brandingDescription;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              updateOrganisation = _this.props.updateOrganisation;
              brandingDescription = _this.state.organisationInfo.brandingDescription;
              updateOrganisation({
                brandingDescription: brandingDescription
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleCoverImageUpload", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(files) {
        var _files$slice, _files$slice2, file, organisationId, brandingCoverImageKey, _this$props2, apolloClient, updateOrganisation, url;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.setState({
                  coverImageSaving: true
                });

                _files$slice = files.slice(-1), _files$slice2 = _slicedToArray(_files$slice, 1), file = _files$slice2[0];
                organisationId = _this.props.organisationId;
                brandingCoverImageKey = (0, _utils.buildOrganisationBucketKey)(organisationId, 'brandingCoverImage');
                _this$props2 = _this.props, apolloClient = _this$props2.apolloClient, updateOrganisation = _this$props2.updateOrganisation;
                _context4.prev = 5;
                _context4.next = 8;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apolloClient,
                  bucketKey: brandingCoverImageKey,
                  file: file,
                  organisationId: organisationId
                });

              case 8:
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](5);
                (0, _commonReact.notify)({
                  content: 'Something went wrong.',
                  type: 'error'
                });

              case 13:
                url = file.preview.url;

                _this.setState({
                  localCoverImageUrl: url,
                  coverImageSaving: false
                });

                updateOrganisation({
                  brandingCoverImageKey: brandingCoverImageKey
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[5, 10]]);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleSaveOrganisationImage", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(files) {
        var _files$slice3, _files$slice4, file, _this$props3, organisationId, updateSelectedOrganisationData, organisationImageUrlKey, _this$props4, apolloClient, updateOrganisation, url;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _files$slice3 = files.slice(-1), _files$slice4 = _slicedToArray(_files$slice3, 1), file = _files$slice4[0];
                _this$props3 = _this.props, organisationId = _this$props3.organisationId, updateSelectedOrganisationData = _this$props3.updateSelectedOrganisationData;
                organisationImageUrlKey = (0, _utils.buildOrganisationBucketKey)(organisationId, 'imageUrl');
                _this$props4 = _this.props, apolloClient = _this$props4.apolloClient, updateOrganisation = _this$props4.updateOrganisation;
                _context5.prev = 4;
                _context5.next = 7;
                return (0, _clientAwsS.uploadFile)({
                  apiClient: apolloClient,
                  bucketKey: organisationImageUrlKey,
                  file: file,
                  organisationId: organisationId
                });

              case 7:
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](4);
                (0, _commonReact.notify)({
                  content: 'Something went wrong.',
                  type: 'error'
                });

              case 12:
                url = file.preview.url;

                _this.setState({
                  localOrganisationImageUrl: url
                });

                updateSelectedOrganisationData({
                  imageUrl: url
                });
                updateOrganisation({
                  imageUrl: organisationImageUrlKey
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[4, 9]]);
      }));

      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleCreateNewBrand", function () {
      var history = _this.props.history;
      history.push('/brand/edit');
    });

    _defineProperty(_assertThisInitialized(_this), "gotoBrand", function (subBrandId) {
      return function () {
        var history = _this.props.history;
        history.push("brand/".concat(subBrandId));
      };
    });

    _this.state = {
      modal: '',
      coverImageSaving: false,
      organisationInfo: {},
      subBrands: [],
      error: false
    };
    return _this;
  }

  _createClass(Organisation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevOrganisationId = prevProps.organisationId;
      var organisationId = this.props.organisationId;

      if (organisationId === prevOrganisationId) {
        return;
      }

      this.fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          history = _this$props5.history,
          name = _this$props5.name,
          permissions = _this$props5.permissions,
          containerSize = _this$props5.containerSize;
      var _this$state = this.state,
          modal = _this$state.modal,
          coverImageSaving = _this$state.coverImageSaving,
          subBrands = _this$state.subBrands,
          localCoverImageUrl = _this$state.localCoverImageUrl,
          localOrganisationImageUrl = _this$state.localOrganisationImageUrl,
          error = _this$state.error,
          _this$state$organisat = _this$state.organisationInfo;
      _this$state$organisat = _this$state$organisat === void 0 ? {} : _this$state$organisat;
      var brandingDescription = _this$state$organisat.brandingDescription,
          brandingCoverImageKey = _this$state$organisat.brandingCoverImageKey,
          imageUrl = _this$state$organisat.imageUrl,
          orgPackage = _this$state$organisat.package,
          accountManager = _this$state$organisat.accountManager;

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
      }

      var hasManagePermission = (0, _commonReact.hasPermission)('MANAGE_ORGANISATION', permissions);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "organisation page"
      }, /*#__PURE__*/_react.default.createElement(_components.PageHeaderWithBackground, {
        title: "My Organisation",
        subtitle: name || '',
        imageUrl: localCoverImageUrl || brandingCoverImageKey,
        handleFilesChange: this.handleCoverImageUpload,
        buttonBusy: coverImageSaving,
        hasManagePermission: hasManagePermission
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "organisation__main"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "column"
      }, /*#__PURE__*/_react.default.createElement(_components.BrandingDescription, {
        name: name || '',
        containerSize: containerSize,
        imageUrl: localOrganisationImageUrl || imageUrl,
        descriptionText: brandingDescription,
        handleClick: this.handleEditDetailsBtnClick,
        showEditDetailsModal: modal === 'edit-details',
        handleModalClose: this.handleCloseEditDetailsModal,
        handleModalSave: this.handleModalSave,
        handleDescriptionInputChange: this.handleDescriptionInputChange,
        handleUploadImage: this.handleSaveOrganisationImage,
        hasManagePermission: hasManagePermission
      }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_BrandSummaryList.default, {
        brands: subBrands,
        gotoBrand: this.gotoBrand,
        handleClick: this.handleCreateNewBrand,
        hasManagePermission: hasManagePermission
      }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_Subscription.default, {
        containerSize: containerSize,
        orgPackage: orgPackage,
        accountManager: accountManager,
        hasManagePermission: hasManagePermission,
        history: history
      }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_ManageTeams.default, {
        orgUserAllowance: orgPackage && orgPackage.userAllowance,
        history: history
      }))));
    }
  }]);

  return Organisation;
}(_react.Component);

exports.default = Organisation;